module.exports = __webpack_public_path__ + "assets/img/folding-animation.b360cbe001c7922345a499c2f78dfcd9.gif";